import { assign } from 'xstate';
import _ from 'underscore';

export const defaultContext = {
  flags: {
    isRSADone: false,
    isTextAdsDone: false,
    isImageAdsDone: false,
    isImagesDone: false,
    isTargetsDone: false,
    isKeywordsDone: false,
    isBudgetDone: false,
    isBIDone: false,
    allDone: false,
  },
  inputs: {
    isSmartMode: true,
    isPMaxLite: false,
    url: undefined,
    language: undefined,
    categoryIds: [],
  },
  outputs: {},
};

export const actions = {
  markRSADone: assign({
    flags: context => ({
      ...context.flags,
      isRSADone: true,
    }),
  }),
  markTextAdsDone: assign({
    flags: context => ({
      ...context.flags,
      isTextAdsDone: true,
    }),
  }),
  markImageAdsDone: assign({
    flags: context => ({
      ...context.flags,
      isImageAdsDone: true,
    }),
  }),
  markImagesDone: assign({
    flags: context => ({
      ...context.flags,
      isImagesDone: true,
    }),
  }),
  markTargetsDone: assign({
    flags: context => ({
      ...context.flags,
      isTargetsDone: true,
    }),
  }),
  markKeywordsDone: assign({
    flags: context => ({
      ...context.flags,
      isKeywordsDone: true,
    }),
  }),
  markBudgetDone: assign({
    flags: context => ({
      ...context.flags,
      isBudgetDone: true,
    }),
  }),
  markBIDone: assign({
    flags: context => ({
      ...context.flags,
      isBIDone: true,
    }),
  }),
  markAllFlagsDone: assign({
    flags: context => ({
      ...context.flags,
      allDone: true,
    }),
  }),

  resetFlags: assign({
    flags: () => ({
      ...defaultContext.flags,
    }),
  }),
  resetOutputs: assign({
    outputs: () => ({
      ...defaultContext.outputs,
    }),
  }),
  updateInputs: assign({
    inputs: (context, event) => _.defaults({
      isPMaxLite: event.isPMaxLite,
      isSmartMode: event.isSmartMode,
      url: event.url,
      language: event.language,
      categoryIds: event.categoryIds,
    }, context.inputs),
  }),
  updateOutputs: assign({
    outputs: (context, event) => _.defaults({
      rsa: event.rsa,
      textAds: event.textAds,
      imageAds: event.imageAds,
      images: event.images,
      targets: event.targets,
      keywords: event.keywords,
    }, context.outputs),
  }),

  assignRSAData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      rsa: event.data,
    }),
  }),
  assignTextAdsData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      textAds: event.data,
    }),
  }),
  assignImageAdsData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      imageAds: event.data,
    }),
  }),
  assignImagesData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      images: event.data,
    }),
  }),
  assignTargetsData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      targets: event.data,
    }),
  }),
  assignKeywordsData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      keywords: event.data,
    }),
  }),
  assignBudgetData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      budget: event.data,
    }),
  }),
  assignBIData: assign({
    outputs: (context, event) => ({
      ...context.outputs,
      bi: event.data,
    }),
  }),
};
